import type { ComputedRef } from '@nuxtjs/composition-api';
import { computed, ref } from '@nuxtjs/composition-api';
import { SALESFORCE_FORM_INDICATOR } from '~/constants/salesforce';
import { SalesforceFormIndicatorValue } from '~/types/salesforce';

export const useWebformShortcuts = (
  selectedSubreasonIndicator: ComputedRef<SalesforceFormIndicatorValue>,
) => {
  const shortcutSubreasons: SalesforceFormIndicatorValue[] = [
    SALESFORCE_FORM_INDICATOR.SALESFORCE_SUBREASON_NO_REASON,
    SALESFORCE_FORM_INDICATOR.SALESFORCE_SUBREASON_INVOICE_REQUEST,
    SALESFORCE_FORM_INDICATOR.SALESFORCE_SUBREASON_SHIPMENT_STATUS,
  ];

  const shouldContinue = ref(false);

  const shortcutEnabled = computed<boolean>(() => {
    return !!selectedSubreasonIndicator.value &&
      shortcutSubreasons.includes(selectedSubreasonIndicator.value);
  });

  const showShortcut = computed<boolean>(() => {
    return shortcutEnabled.value && !shouldContinue.value;
  });

  const showNextSteps = computed<boolean>(() => {
    return !!selectedSubreasonIndicator.value && !showShortcut.value;
  });

  const onContinue = () => {
    shouldContinue.value = true;
  };

  const resetContinueState = () => {
    shouldContinue.value = false;
  };

  return {
    showShortcut,
    showNextSteps,
    onContinue,
    resetContinueState,
  };
};

export default useWebformShortcuts;
